<template>
    <div class="counter p-2 flex-fill text-center">
        <h2><number v-bind:to="to"></number></h2>
        <p>{{ label }}</p>
    </div>
</template>

<script>
    import VueNumber from 'vue-number-animation'

    Vue.use(VueNumber)
    export default {
        name: "counter",
        components: {VueNumber},
        props: ['to','label']
    }
</script>

<style scoped>

</style>
